import { InjectionToken } from '@angular/core';
import { AbstractJobService } from '@y42/job';

export const DatasourceTableJobServiceInjectionToken = new InjectionToken<AbstractJobService[]>(
  'DatasourceTableJobServiceInjectionToken',
);
